import { useContext } from 'react';

import { useParams } from 'react-router-dom';

import { CorePermissions } from '@/core/api/collections/users';
import { AuthContext } from '@/core/auth/AuthContext';
import { ERROR_NO_SELF_CHANGES, ERROR_NOT_AN_ADMIN } from '@/core/users/UserPermissions/constants';
import { EditPermissions } from '@/core/users/UserPermissions/EditPermissions';
import { UserEditContext } from '@/core/users/UserPermissions/UserEditContext';
import { UserPermissionTab } from '@/core/users/UserPermissions/UserPermissionsTabs';

export function UserPermissionsEditPermissionsContainer () {
  const { currentUser } = useContext(AuthContext);
  const { toggleAccess, user, updateUser } = useContext(UserEditContext);
  const { tab } = useParams() as { tab?: UserPermissionTab };

  let coreDisabledMessage: string | undefined;
  let uvkDisabledMessage: string | undefined;
  if (currentUser!.id === user!.id) {
    coreDisabledMessage = ERROR_NO_SELF_CHANGES;
    uvkDisabledMessage = ERROR_NO_SELF_CHANGES;
  } else {
    if (!currentUser!.coreOwner) {
      coreDisabledMessage = ERROR_NOT_AN_ADMIN;
    }
    if (!currentUser!.uvkAdmin) {
      uvkDisabledMessage = ERROR_NOT_AN_ADMIN;
    }
  }

  function setCorePermission<K extends keyof CorePermissions>(key: K, value: CorePermissions[K]) {
    if (!user?.permissions.core) return;
    user!.permissions.core[key] = value;
    updateUser(user!);
  }

  return tab === undefined || tab === 'permissions' ? (
    <EditPermissions
      permissions={user!.permissions}
      coreDisabledMessage={coreDisabledMessage}
      uvkDisabledMessage={uvkDisabledMessage}
      onCorePermissionChanged={setCorePermission}
      toggleAccess={toggleAccess}
    />
  ) : null;
}
